import React, { useEffect, useRef, useState } from 'react';
import { Button, Form, Input } from 'antd';
import { useTranslation } from 'react-i18next';
import regex from '../../constants/system.keys';
import LocationSearchLocationIQ from '../../components/LocationSearchLocationIQ';

const layout = {
  labelCol: { span: 4 },
  wrapperCol: { span: 18 },
};

const CreateMarkerComponent = ({ onCreateMarker }) => {
  const [address, setAddress] = useState();
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const [, forceUpdate] = useState();
  const nameInput = useRef(null);

  useEffect(() => {
    forceUpdate({});
  }, []);

  useEffect(() => {
    if (nameInput.current) {
      setTimeout(() => { nameInput.current.input.focus() }, 1)
    }
  }, [nameInput]);

  const [isBlock, setIsBlock] = useState(false);
  const handleAddressChange = (address) => {
    form.setFieldsValue({
      location: address,
    });
    setAddress((state) => ({
      ...state,
      note: address,
    }));
  };
  const onFinish = (values) => {
    form.resetFields();
    onCreateMarker(values);
    return setAddress(null);
  };
  useEffect(() => {
    return () => {
      setAddress(null);
      setIsBlock(false);
    };
  }, []);

  const handleSelect = (address) => {
    setAddress(address);
    form.setFieldsValue({
      lat: address?.lat,
      lng: address?.lng,
      location: address?.note ?? '',
    })
  };

  return (
    <div className="create-marker-component">
      <Form form={form} {...layout} onFinish={onFinish} name="form_in_modal">
        <Form.Item
          name="name"
          label={t('Marker')}
          rules={[
            {
              required: true,
              message: t('Please input the name of the marker!'),
            },
            {
              pattern: regex.isName,
              message: t('Please enter only letters and numbers!'),
            },
            {
              max: 200,
              message: t('Please input up to 200 characters!'),
            },
          ]}
        >
          <Input ref={nameInput} placeholder={t('Name of the quick access point ...')} />
        </Form.Item>

        <Form.Item
          name="location"
          label={t('Location')}
          rules={[
            {
              required: true,
              message: t('Please select the location'),
            },
            {
              pattern: regex.isName,
              message: t('Please enter only letters and numbers!'),
            },
            {
              max: 200,
              message: t('Please input up to 200 characters!'),
            },
          ]}
        >
          <LocationSearchLocationIQ
            address={address?.note}
            onChange={handleAddressChange}
            onAddressSelect={handleSelect}
            setIsBlock={setIsBlock}
          />
        </Form.Item>
        <div className="create-btn">
          <Form.Item shouldUpdate={true}>
            <Button htmlType="submit" disabled={isBlock}>
              {t('Create')}
            </Button>
          </Form.Item>
        </div>
        <div className="top-lat-lng" />
        <div className="lat-lng">
          <Form.Item name="lat">
            <Input disabled placeholder="Latitude" />
          </Form.Item>

          <Form.Item name="lng">
            <Input disabled placeholder="Longitude" />
          </Form.Item>
        </div>
      </Form>
    </div>
  );
};

export default CreateMarkerComponent;
